import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as Plotscripts from "@frog/source/data/plotscripts.js"
import Navigation from "@frog/source/models/admin/Navigation.js"

const PLAYER_CHARACTER = "captain"

function areAllAffiliatedUnitsDefeated(stage, {affiliation}) {
    const remainingUnits = Object.values(stage.units).filter((unit) => {
        return unit.affiliation != "good"
            && (unit.isDead != true && unit.hasBeenRemoved != true)
    })
    return remainingUnits.length == 0
}

function areAllButOneUnitsDefeated(stage) {
    const remainingUnits = Object.values(stage.units).filter((unit) => {
        return unit.isDead != true
    })
    return remainingUnits.length == 1
}

function Betrayal(stage) {
    const deltastages = []

    const remainingUnits = Random.shuffle(Object.values(stage.units).filter((unit) => {
        return unit.isDead != true
            && unit.key != PLAYER_CHARACTER
    }))

    const affiliations = ["bad", "neutral", "good"]
    remainingUnits.forEach((unit, index) => {
        deltastages.push({
            "unit": {
                "key": unit.key,
                "affiliation": affiliations[index % affiliations.length],
                "bodyKey": affiliations[index % affiliations.length],
            }
        })
    })

    if(stage.tags["hasBeenBetrayed"]?.value != true) {
        deltastages.push({
            "turn": {
                "number": 2,
            }
        })
        deltastages.push({
            "tag": {
                "name": "hasBeenBetrayed",
                "value": true,
            }
        })
    } else {
        deltastages.push({
            "tag": {
                "name": "hasBeenBetrayedAgain",
                "value": true,
            }
        })
    }

    return {
        "deltastages": deltastages
    }
}

export default {
    "slug": "ship",
    "hasPreparePhase": false,

    "stage": {
        "image": require("./image.png"),
        "units": require("./units.json"),
        "world": Tiled.parse({
            "tilemap": require("./tiles.json"),
            "tileset": require("@frog/source/data/levels/tileset.json"),
        }),
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    {"func": () => Audiomix.trigger("Music:Combat:3")},
                    Plotscripts.SpawnPlayerPartyScript(),
                    Plotscripts.Dialogue({
                        "text": "Avast!",
                        "class": "captain",
                    }),
                    Plotscripts.Dialogue({
                        "text": "The loot is ours, and ours alone!\nAnd no damned undead will tell\nme otherwise.",
                        "class": "captain",
                    }),
                    Plotscripts.Dialogue({
                        "text": "The crew of the damned have\nboarded, captain!",
                        "class": "cabinboy",
                    }),
                    Plotscripts.Dialogue({
                        "text": "These cold dead bastards will\nhave to wretch it from me cold\ndead hands.",
                        "class": "mercenary",
                    }),
                    Plotscripts.Dialogue({
                        "text": "We fight to the last man, each\nand every one of us.",
                        "class": "captain",
                    }),
                    Plotscripts.Dialogue({
                        "text": "Aye aye, captain.",
                        "class": "missionary",
                    }),
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return areAllAffiliatedUnitsDefeated(stage, {"affiliation": "good"})
                        && areAllButOneUnitsDefeated(stage) != true
                        && stage.units[PLAYER_CHARACTER].isDead != true
                        && stage.tags["hasBeenBetrayed"]?.value != true
                },
                "events": [
                    Plotscripts.Dialogue({
                        "text": "Back to Davy Jones with you!!\nTell him who sent you.",
                        "class": "captain",
                    }),
                    (stage) => {
                        if(stage.units["missionary"] != undefined
                        && stage.units["missionary"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "...",
                                "class": "missionary",
                            })
                        }
                    },
                    (stage) => {
                        if(stage.units["mercenary"] != undefined
                        && stage.units["mercenary"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "....",
                                "class": "mercenary",
                            })
                        }
                    },
                    (stage) => {
                        if(stage.units["cabinboy"] != undefined
                        && stage.units["cabinboy"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": ".....",
                                "class": "cabinboy",
                            })
                        }
                    },
                    (stage) => {
                        return Betrayal(stage)
                    },
                    {
                        "type": "func",
                        "func": function() {
                            Audiomix.trigger("Music:Combat:1")
                        }
                    },
                    (stage) => {
                        if(stage.units["cabinboy"].affiliation == "bad") {
                            return Plotscripts.Dialogue({
                                "text": "Captain, this is a mutiny.\nWe're cutting you out of the loot.",
                                "class": "cabinboy",
                            })
                        } else if(stage.units["mercenary"].affiliation == "bad") {
                            return Plotscripts.Dialogue({
                                "text": "You should tell Jones yourself,\ncaptain. This loot is ours.",
                                "class": "mercenary",
                            })
                        } else if(stage.units["missionary"].affiliation == "bad") {
                            return Plotscripts.Dialogue({
                                "text": "Captain, drop the loot.\nYou don't know what it can do.",
                                "class": "missionary",
                            })
                        }
                    },
                    (stage) => {
                        if(stage.units["cabinboy"].affiliation == "undead") {
                            return Plotscripts.Dialogue({
                                "text": "Hey, hands off, bastards!\nThe gold is mine!!",
                                "class": "cabinboy",
                            })
                        } else if(stage.units["mercenary"].affiliation == "undead") {
                            return Plotscripts.Dialogue({
                                "text": "Draw your blade, capn, if you dare.",
                                "class": "mercenary",
                            })
                        } else if(stage.units["missionary"].affiliation == "undead") {
                            return Plotscripts.Dialogue({
                                "text": "This is for the best.\nDrop your weapon.",
                                "class": "missionary",
                            })
                        }
                    },
                    Plotscripts.Dialogue({
                        "text": "So you've chosen an early death.",
                        "class": "captain",
                    }),
                    (stage) => {
                        if(stage.units["cabinboy"].affiliation == "good"
                        && stage.units["cabinboy"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "Get back, you bastards!\nI'm with you, captain!",
                                "class": "cabinboy",
                            })
                        } else if(stage.units["mercenary"].affiliation == "good"
                        && stage.units["mercenary"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "I'm still with you, captain! I have\nyour back if you have mine.",
                                "class": "mercenary",
                            })
                        } else if(stage.units["missionary"].affiliation == "good"
                        && stage.units["missionary"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "I'm at your call, captain.",
                                "class": "missionary",
                            })
                        }
                    },
                    Plotscripts.Dialogue({
                        "text": "Come, you curs!!\nBreak your weapons on me.",
                        "class": "captain",
                    })
                ]
            },

            // {
            //     "type": "condition",
            //     "condition": function(stage) {
            //         return stage.turn.number == 5
            //             && stage.tags["hasBeenBetrayed"]?.value == true
            //     },
            //     "events": [
            //         {
            //             "type": "spawn",
            //             "unit": {
            //                 "affiliation": "bad",
            //                 "key": "sharpshooter",
            //                 "position": {"x": 7, "y": 4},
            //             }
            //         },
            //         Plotscripts.Dialogue({
            //             "text": "No more skeles to the east-",
            //             "class": "sharpshooter",
            //         }),
            //         Plotscripts.Dialogue({
            //             "text": "Ah, a mutiny, then? I'm in.",
            //             "class": "sharpshooter",
            //         }),
            //     ],
            // },
            // {
            //     "type": "condition",
            //     "condition": function(stage) {
            //         return stage.turn.number == 6
            //             && stage.tags["hasBeenBetrayed"]?.value == true
            //             && stage.units[PLAYER_CHARACTER].isDead != true
            //     },
            //     "events": [
            //         {
            //             "type": "spawn",
            //             "unit": {
            //                 "affiliation": "good",
            //                 "key": "firstmate",
            //                 "position": {"x": 13, "y": 6},
            //             }
            //         },
            //         Plotscripts.Dialogue({
            //             "text": "Captain, I'm here to help!",
            //             "class": "firstmate",
            //         }),
            //         Plotscripts.Dialogue({
            //             "text": "Ay, Smee!! Took you long enough!!",
            //             "class": "captain",
            //         }),
            //         Plotscripts.Dialogue({
            //             "text": "It's, uh, Roberts, sir.",
            //             "class": "firstmate",
            //         }),
            //     ]
            // },

            {
                "type": "condition",
                "condition": function(stage) {
                    return areAllAffiliatedUnitsDefeated(stage, {"affiliation": "good"})
                        && areAllButOneUnitsDefeated(stage) != true
                        && stage.units[PLAYER_CHARACTER].isDead != true
                        && stage.tags["hasBeenBetrayed"]?.value == true
                        && stage.tags["hasBeenBetrayedAgain"]?.value != true
                },
                "events": [
                    Plotscripts.Dialogue({
                        "text": "And that's that!!",
                        "class": "captain",
                    }),
                    (stage) => {
                        if(stage.units["firstmate"] != undefined
                        && stage.units["firstmate"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "...",
                                "class": "firstmate",
                            })
                        }
                    },
                    (stage) => {
                        const unit = Object.values(stage.units).find((unit) => {
                            return unit.class != "firstmate"
                                && unit.class != "captain"
                                && unit.isDead != true
                                && unit.affiliation == "good"
                        })
                        if(unit != undefined) {
                            return Plotscripts.Dialogue({
                                "text": ".....",
                                "class": unit.class,
                            })
                        }
                    },
                    (stage) => {
                        return Betrayal(stage)
                    },
                    (stage) => {
                        const unit = Object.values(stage.units).find((unit) => {
                            return unit.class != "firstmate"
                                && unit.class != "captain"
                                && unit.isDead != true
                                && unit.affiliation == "good"
                        })
                        if(unit != undefined) {
                            return Plotscripts.Dialogue({
                                "text": "I'm afraid this is as\nfar as you go, captain.",
                                "class": unit.key,
                            })
                        }
                    },
                    (stage) => {
                        if(stage.units["firstmate"] != undefined
                        && stage.units["firstmate"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "Smee, you too?",
                                "class": "captain",
                            })
                        }
                    },
                    (stage) => {
                        if(stage.units["firstmate"] != undefined
                        && stage.units["firstmate"].isDead != true) {
                            return Plotscripts.Dialogue({
                                "text": "It's Roberts, sir. Engaurd!",
                                "class": "firstmate",
                            })
                        }
                    },
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return areAllButOneUnitsDefeated(stage)
                        && stage.units[PLAYER_CHARACTER].isDead != true
                },
                "events": [
                    {"func": () => Audiomix.trigger("Music:Menu")},
                    Plotscripts.Dialogue({
                        "text": "Huzzah! Fall before me, you dogs.\nNo booty for backstabbers.",
                        "class": "captain",
                    }),
                    Plotscripts.Dialogue({
                        "text": "...",
                        "class": "captain",
                    }),
                    Plotscripts.Dialogue({
                        "text": "Now how am I going to get this\nship back to port?",
                        "class": "captain",
                    }),
                    {"type": "chapter success"},
                    {"func": () => Navigation.go("/games/pirates")},
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return stage.units[PLAYER_CHARACTER].isDead == true
                },
                "events": [
                    {"type": "chapter failure"},
                    {"func": () => App.game.chapter.restart()},
                ]
            },
        ]
    },
}
